const createBqIntegration = async ({ params, api }) => {
  return await api('bqIntegration', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createBqIntegration;